import { staticColors } from '../../const/colors/staticColors';
import { sizes } from '../../const/sizes';
export const getDotBackgroundColor = (tagColor) => {
    const backgroundColorMap = {
        warning: staticColors.dotWarningBackground,
        danger: staticColors.dotDangerBackground,
        grey: staticColors.dotGreyBackground,
        success: staticColors.dotSuccessBackground,
    };
    return backgroundColorMap[tagColor];
};
export const getDotSize = (dotSize) => {
    const sizeMap = {
        small: { width: sizes.dot.small.width, height: sizes.dot.small.height },
        medium: { width: sizes.dot.medium.width, height: sizes.dot.medium.height },
        large: { width: sizes.dot.large.width, height: sizes.dot.large.height },
    };
    return sizeMap[dotSize];
};
